/*
 *  Author: DL
 *  Date: 2020-12-16 11:49:24
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-16 13:41:24
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useCallback } from 'react';
import Button from '../Button';
import styles from './index.less';

function Confirm(props) {
    const { message = '', visible = false, onOK = () => {}, onClose = () => {}, onCancel = () => {} } = props;

    const handleOnOk = useCallback(() => {
        onOK();
        onClose();
    }, [onOK, onClose]);

    const handleOnCancel = useCallback(() => {
        onCancel();
        onClose();
    }, [onCancel, onClose]);

    return visible ? (
        <div className={styles.wrapper}>
            <div className={styles.contentWrapper}>
                <div className={styles.text}>{message}</div>
                <div className={styles.bttn}>
                    <Button type="primary" onClick={handleOnOk}>
                        确定
                    </Button>
                    <Button onClick={handleOnCancel}>取消</Button>
                </div>
            </div>
        </div>
    ) : null;
}

export default Confirm;
